import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function GallerySection() {
  const ref = useRef<HTMLElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-dark px-6 py-20 md:py-26" aria-label="Property aerial view" data-id="element-69">
      <div className="mx-auto max-w-6xl" data-id="element-70">
        <motion.div className="mb-12 text-center" initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }} data-id="element-71">
          <p className="font-heading text-xs font-bold tracking-widest-plus uppercase text-accent mb-4" data-id="element-72">
            Aerial Perspective
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white" data-id="element-73">
            Site Overview
          </h2>
        </motion.div>

        <motion.div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.25, 0.1, 0.25, 1]
      }} data-id="element-74">
          <img src="https://cdn.magicpatterns.com/uploads/fFM58zjKxbpfBiBnaujuow/120-124_Dryburgh_Street,_North_Melbourne_RC_v063.jpg" alt="Aerial view of 120-124 Dryburgh Street showing property boundaries and 355sqm land size" className="w-full h-auto object-cover" data-id="element-75" />

          {/* Overlay gradient for depth */}
          <div className="absolute inset-0 bg-gradient-to-t from-dark/40 to-transparent pointer-events-none" data-id="element-76" />
        </motion.div>
      </div>
    </section>;
}